import { render } from "./ReportsStreamsDetails.vue?vue&type=template&id=47949a50&scoped=true"
import script from "./ReportsStreamsDetails.vue?vue&type=script&lang=js"
export * from "./ReportsStreamsDetails.vue?vue&type=script&lang=js"

import "./ReportsStreamsDetails.vue?vue&type=style&index=0&id=47949a50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47949a50"]])

export default __exports__